/** 行・列ハイライトの下地。ステータス色の上に薄く重ねる（*.tsx に置き Tailwind に拾わせる） */
export const RATE_MATRIX_HIGHLIGHT_OVERLAY_CLASS =
	"shadow-[inset_0_0_0_9999px_rgb(24_24_27_/_0.06)]";

/** 交差セル（ホバー中のマス）は一段濃くする */
export const RATE_MATRIX_HIGHLIGHT_CROSS_CLASS =
	"shadow-[inset_0_0_0_9999px_rgb(24_24_27_/_0.1)]";

/** テスト・デバッグ用。見た目はクラス側、セレクタは data 属性側 */
export const RATE_MATRIX_HIGHLIGHT_ATTR = "data-rate-matrix-highlight";
export type RateMatrixHighlightKind = "row" | "column" | "cross";
